import { BaseItemStore } from "../../core/BaseStore";
import type { BusinessFeedCommentReplyModel } from "./BusinessFeedCommentReplyModel";

export default class BusinessFeedCommentsReplyStore extends BaseItemStore<BusinessFeedCommentReplyModel> {}
